// adding max characters (excluding spaces) in credit card input field

const rule = {
	name: 'maxlengthExcludingSpaces',
	method: (value, element, params) => value.replace(/[\s-]/g, '').length <= 25,
	errorMessage: (params, element) => 'Please enter no more than 25 characters.'
};

export default rule;
